import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import {ModuleList} from "../models/moduleList";
import {ModuleService} from "../services/module.service";


@Injectable()
export class ModulesResolve implements Resolve<ModuleList> {
    constructor(private moduleService: ModuleService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<ModuleList> {
        return this.moduleService.getAll();
    }
}
